import { render, staticRenderFns } from "./AccountDeletion.vue?vue&type=template&id=d7ecf1c6&scoped=true"
import script from "./AccountDeletion.vue?vue&type=script&lang=ts"
export * from "./AccountDeletion.vue?vue&type=script&lang=ts"
import style0 from "./AccountDeletion.vue?vue&type=style&index=0&id=d7ecf1c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ecf1c6",
  null
  
)

export default component.exports